<!--
@Author: MIYONGLE
@Desc: 关于我们 - 了解我们
@Date: 2021-07-29 13时
-->
<template>
  <div>

    <!-- 慧用工简介 -->
    <span class="title-text">慧用工简介</span>
    <p class="about-sec">
      慧用工成立于2019年2月，是一家场景化灵活用工服务平台。
      <br><br>
      慧用工致力于灵活用工领域，致于服务2亿灵活用工从业者。目前为全国共享经济业态企业提供新经济灵活用工招募、用工管理、用工结算等全链条灵活用工服务。基于对不同垂直细分行业的深耕，已经为保险、电商、货运等垂直行业提供场景化解决方案和增值服务。经过一年的发展，慧用工构建了覆盖全国范围的自营团队+服务商网络，服务覆盖40余个细分行业7000余家企业客户，数百万自由职业者。
      <br><br>
      慧用工作为承载新个体经济健康发展的新经济平台，将继续创新以互联网技术为依托促进更多自由职业者多渠道就业创业，为稳就业保民生贡献力量。在做好灵活用工平台的同时，将积极探索新业态新模式下的发展道路，发展共享经济，为我国的新经济发展做出贡献。
    </p>
    <img src='../../../static/mobile/aboutUs/aboutus_img.png' alt="慧用工" class="img_hyg"/>

    <!-- 发展历程 -->
    <span class="title-text">发展历程</span>

    <!-- 轮播 -->
    <div class="dev-swipe">
      <van-swipe :autoplay="4000" class="dev-swipe-con" @change="onChangeSwipe" 
      :show-indicators='isIndicators' ref="swiper">
        <van-swipe-item class="dev-swipe-item">
          <span class="swipe-item-span">2019</span>
          <div class="swipe-item-desc">
            <p><span>2月</span><span>海南慧用工服务有限公司注册成立</span></p>
            <p><span>4月</span><span>慧用工1.0系统上线，并试运营</span></p>
            <p><span>9月</span><span>慧用工2.0系统上线，且单月发薪额过亿元</span></p>
            <p><span>12月</span><span>运行9个月时间，累计交易额突破10亿元</span></p>
          </div>
        </van-swipe-item>

        <van-swipe-item class="dev-swipe-item">
          <span class="swipe-item-span">2020</span>
          <div class="swipe-item-desc">
            <p><span>5月</span><span>慧用工被海南省税务局评为《灵活用工平台标杆企业》</span></p>
            <p><span>6月</span><span>建立江西共青城分部，个体户集群注册产品上线 </span></p>
            <p><span>11月</span><span>建立江西永修分部</span></p>
            <p><span>12月</span><span>搭建新业态、金融、地产、即配等垂直行业事业部，强化垂直行业个性化服务质量</span></p>
          </div> 
        </van-swipe-item>

        <van-swipe-item class="dev-swipe-item">
          <span class="swipe-item-span">2021</span>
          <div class="swipe-item-desc">
            <p><span>3月</span><span>衡阳慧用工分公司成立</span></p>
            <p><span>5月</span><span>湖南慧用工分公司成立 </span></p>
            <p><span>5月</span><span>慧用工获企业信用AAA证书</span></p>
            <p><span>10月</span><span>湖南慧用工获“2021年度中国区最佳人力资本服务”企业奖</span></p>
            <p><span>12月</span><span>交易额过80亿，服务灵活就业者超300万</span></p>
          </div> 
        </van-swipe-item>

        <van-swipe-item class="dev-swipe-item">
          <span class="swipe-item-span">2022</span>
          <div class="swipe-item-desc">
            <p><span>3月</span><span>湖南慧用工科技集团有限公司成立</span></p>
            <p><span>4月</span><span>湖南慧用工北京分公司成立 </span></p>
            <p><span>6月</span><span>湖南慧用工上海分公司成立</span></p>
            <p><span>9月</span><span>湖南慧用工杭州分公司成立</span></p>
            <p><span>9月</span><span>交易额过300亿+，服务灵活就业者超1000万+</span></p>
          </div>  
        </van-swipe-item>

        <van-swipe-item class="dev-swipe-item">
          <span class="dev-swipe-item-text">未来，世界很大，一起灵活用工</span>
        </van-swipe-item>
      </van-swipe>

      <!-- 轮播按钮 -->
      <div class="about-bannar">
        <!-- 线 -->
        <div class="line-div"></div>
        <div class="about-bannar-dotton">
          <div v-for="(item,index) of aboutUsBannar" :key="index" @click="goToSwiper(index)">
            <div class="about-bannar-index">
              <span :class="current == index ? 'activeBlock' : ''"></span>
              <span :class="current == index ? 'activeCur' : ''"></span>
            </div>
            <span :class="current == index ? 'activeColor' : ''">{{item}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import {ABOUT_US_BANNAR} from '../../service/businessConsts'
export default {
  name: "mKnow-us",
  data() {
    return {
      aboutUsBannar: ABOUT_US_BANNAR,
      current: 0,
      isIndicators: false,
    }
  },
  components: {
  },
  created() {
  },
  methods: {

    // 获取下标
    onChangeSwipe(index){
      this.current = index;
    },

    // 点击轮播
    goToSwiper(index) {
      this.$refs.swiper.swipeTo(index);
    },
    
  }
}
</script>

<style lang="scss" scoped>
//标题
.title-text{
  margin-top: 103px;
  display: block;
  font-size: 40px;
  font-weight: 600;
  color: #100F0F;
}

.about-sec{
  color: #171E2E;
  font-size: 24px;
  text-align: left;
  line-height: 42px;
  height: 630px;
  font-weight: 400;
  margin-top: 35px;
  margin-bottom: 106px;
  text-align: justify;
  padding: 0 30px;
  box-sizing: border-box;
  word-break : normal;
}

.img_hyg{
  width: 100%;
  height: 300px;
}

// 轮播
.dev-swipe{
  margin-top: 53px;
  margin-bottom: 146px;
  height: 371px;
  background: linear-gradient(180deg, rgba(25, 133, 255, 0.05) 0%, rgba(255, 255, 255, 0) 100%);

  .dev-swipe-con{
    height: 331px;
    width: 100%;
    box-sizing: border-box;
    padding-top: 22px;
    .dev-swipe-item{
      margin-top: 32px;
      display: flex;
      flex-wrap:nowrap;
      color: #171E2E;
      .swipe-item-span{
        font-size: 40px;
        width: 130px;
        transform:rotate(90deg);
        display: block;
        margin-right: 80px;
        position: relative;
        top: -88px;
        right: 59px;
      }

      .swipe-item-desc{
        width: 100%;
        p{
          margin-top: 13px;
          color: #171E2E;
          display: flex;
          span:nth-child(1){
            color: #1985FF;
            margin-right: 8px;
            display: inline-block;
            text-align: left;
          }
          span:nth-child(2){
            color: #171E2E;
            width: 450px;
            display: inline-block;
            text-align: left;
            line-height: 30px;
          }
        }
      }
    }

    .dev-swipe-item-text{
      font-size: 40px;
      color: #171E2E;
      font-weight: bolder;
      text-align: center;
      display: block;
      margin: auto;
    }
  }

  // 锚点
  .about-bannar{
    width: 100%;
    margin-top: 65px;
    .about-bannar-dotton{
      display: flex;
      justify-content: space-between;
      padding: 0 82px;
      box-sizing: border-box;
      color: #403F3F;
      font-size: 22px;
      // font-weight: 600;
      margin-top: -12px;
      div{
        .about-bannar-index{
          span{
            display: block;
            margin: auto;
          }
          span:nth-child(1){
            width: 1px;
            height: 62px;
            background: #1985FF;
            display: none;
          }
          span:nth-child(2){
            width: 12px;
            height: 12px;
            border-radius: 50%;
            border: 1px solid #CFCFCF;
            margin-bottom: 10px;
          }
          span:nth-child(1).activeBlock{
            display: block;
            margin-top: -62px;
          }
          span:nth-child(2).activeCur{
            border: 1px solid #1985FF;
          }
        }
        .activeColor{
          color: #1985FF;
        }
      }
    }

    .line-div{
      width: 100%;
      height: 1px;
      background: #CFCFCF;
    }
  }


}


</style>


// WEBPACK FOOTER //
// src/views/mobile/mKnowUs_aboutUser.vue